module.exports = __webpack_public_path__ + "img/20190415112817.6d2966c6.png";